import { GetCommentReplyListDetailResponseType } from '@frontend/sorghum/interface';
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { COMMENT_REPLY_LIST_DETAIL } from '../apis';

const defaultData = {
  projectChannelId: '',
  conditions: [],
  posts: [],
};

async function getCommentReplyListDetail(
  uuid: string,
): Promise<GetCommentReplyListDetailResponseType> {
  return axios
    .get(`${COMMENT_REPLY_LIST_DETAIL}?id=${uuid}`)
    .then((res) => res.data.data)
    .catch((err) => {
      return defaultData;
    });
}

export function useGetCommentReplyListDetail(uuid: string) {
  return useQuery<GetCommentReplyListDetailResponseType>({
    queryKey: ['get-comment-reply-list-detail', { uuid }],
    queryFn: () => {
      if (uuid) {
        return getCommentReplyListDetail(uuid);
      } else {
        return defaultData;
      }
    },
  });
}
